import React from 'react';
import { TeamMember, UserType } from '@zonofi/zono-money-store';
import { Avatar, CustomRadio, Divider } from '../../components';
import { DividerColorVariant } from '../../constants';
import './team-member-card.scss';

interface TeamMemberCardProps {
  teamMember: TeamMember;
  isFirst?: boolean;
  isLast?: boolean;
  showMetaData?: boolean;
  isSelected?: boolean;
  onSelect?: (teamMember: TeamMember) => void;
}

const formatPhone = (phone?: string) => {
  if (!phone) return 'N/A';
  return phone.startsWith('+') ? phone : `+${phone}`;
};

const formatUserType = (userType?: UserType) => {
  if (!userType) return '';

  switch (userType) {
    case UserType.OWNER:
      return 'Team Owner';
    case UserType.MEMBER:
      return 'Member';
    case UserType.CFA:
      return 'CFA';
    default:
      return userType;
  }
};

export const TeamMemberCard: React.FC<TeamMemberCardProps> = ({
  teamMember,
  isFirst = false,
  isLast = false,
  showMetaData = false,
  isSelected = false,
  onSelect,
}) => {
  const role = formatUserType(teamMember?.userType);
  const assignedCustomers =
    typeof teamMember?.teamCustomers === 'number'
      ? `${teamMember.teamCustomers} customer${
          teamMember.teamCustomers === 1 ? '' : 's'
        }`
      : '';

  const meta = showMetaData
    ? [formatPhone(teamMember?.mobile), role, assignedCustomers].filter(Boolean)
    : [formatPhone(teamMember?.mobile)].filter(Boolean);

  return (
    <div
      className={`team-member-card
        ${isFirst ? 'first-card' : ''}
        ${isLast ? 'last-card' : ''}`}
      onClick={() => onSelect?.(teamMember)}
    >
      <div
        className={`team-member-card-content ${isLast ? 'last-card-margin' : ''}`}
      >
        <div className="team-member-card-info">
          <Avatar
            id={teamMember?.id}
            title={teamMember?.name}
            size={36}
            style={{ marginRight: '12px' }}
          />
          <div className="team-member-card-details">
            <span className="team-member-card-details-name font-medium">
              {teamMember?.name || 'N/A'}
            </span>
            <span className="team-member-card-details-meta font-regular">
              {meta.join(' • ')}
            </span>
          </div>
        </div>
        <div
          className="team-member-card-radio"
          onClick={(e) => {
            e.stopPropagation();
            onSelect?.(teamMember);
          }}
        >
          <CustomRadio checked={isSelected} />
        </div>
      </div>

      {!isLast && (
        <Divider
          className="team-member-card-divider"
          colorVariant={DividerColorVariant.PRIMARY}
        />
      )}
    </div>
  );
};
